import { render, staticRenderFns } from "./BoxReader.vue?vue&type=template&id=690ce0ce&scoped=true&"
import script from "./BoxReader.vue?vue&type=script&lang=js&"
export * from "./BoxReader.vue?vue&type=script&lang=js&"
import style0 from "./BoxReader.vue?vue&type=style&index=0&id=690ce0ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690ce0ce",
  null
  
)

export default component.exports